import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useContentLibrary } from '../../../providers/content_library_provider';
import DocumentResult from './oldDocumentResult';
const TABLE_CHUNK_SIZE = 25;
const OldDocumentSearchTable = ({ documents, queryInfo }) => {
    const { getMoreDocuments, selectedDocuments, selectManyDocuments, toggleSelectedDocument, } = useContentLibrary();
    const [allDocsSelected, setAllDocsSelected] = useState(false);
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (documents.length > 0) {
            setTableData(documents.slice(0, TABLE_CHUNK_SIZE));
        }
    }, [documents]);
    useEffect(() => {
        setAllDocsSelected(documents.every(doc => selectedDocuments.find(sd => sd.id === doc.id)));
    }, [selectedDocuments, documents]);
    const takeMore = () => {
        const endIndex = tableData.length + TABLE_CHUNK_SIZE;
        if (endIndex > documents.length && queryInfo.pageNumber < queryInfo.totalPages) {
            getMoreDocuments();
        }
        else {
            setTableData(documents.slice(0, tableData.length + TABLE_CHUNK_SIZE));
        }
    };
    const handleSelectAllDocuments = () => {
        if (!allDocsSelected) {
            const docsToAdd = documents.filter(doc => !selectedDocuments.find(sd => sd.id === doc.id)).map(doc => { return { id: doc.id, name: doc.source.fileName, txId: '', docType: '' }; });
            selectManyDocuments(docsToAdd, false);
        }
        else {
            const docsToRemove = documents.map(doc => { return { id: doc.id, name: doc.source.fileName, txId: '', docType: '' }; });
            selectManyDocuments(docsToRemove, true);
        }
    };
    const handleSelectDocument = (doc) => {
        toggleSelectedDocument({ id: doc.id, name: doc.source.fileName, txId: '', docType: '' });
    };
    const totalRows = (documents === null || documents === void 0 ? void 0 : documents.length) || 0;
    return (React.createElement("div", { className: 'old-document-search-results' },
        React.createElement("p", { className: 'results-count' },
            "Document Results ",
            React.createElement("b", null,
                "(",
                documents.length,
                ")")),
        React.createElement("div", { className: 'results-table-header' },
            React.createElement("h5", { className: 'check-col' },
                React.createElement("input", { id: 'select-all-documents', type: 'checkbox', className: 'input', checked: allDocsSelected, onChange: handleSelectAllDocuments })),
            React.createElement("h5", { className: 'doc-col' }, "Document Name"),
            React.createElement("h5", { className: 'name-col' }, "Form Name"),
            React.createElement("h5", { className: 'num-col' }, "Form Number"),
            React.createElement("h5", { className: 'date-col' }, "Edition Date")),
        React.createElement("div", { className: 'results-table-items', id: 'scrollable-results' },
            React.createElement(InfiniteScroll, { dataLength: tableData.length, next: takeMore, hasMore: (tableData.length !== totalRows) ||
                    (queryInfo.pageNumber < queryInfo.totalPages), loader: React.createElement("div", { className: 'loading-results', "data-public": true }, "Loading More Documents..."), scrollableTarget: 'scrollable-results' }, tableData.map(doc => {
                const selected = !!(selectedDocuments.find(sd => sd.id === doc.id));
                return React.createElement(DocumentResult, { key: `${doc.id}-${doc.score}`, doc: doc, selected: selected, handleSelectDocument: handleSelectDocument });
            })))));
};
export default OldDocumentSearchTable;
